module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/icon-friend-circle.69fd9e39.png";